import api from './axios';
import { ApiResponse, Player, Registration } from '../types';

export type EventRegistrationPayload = {
  teamName: string;
  players: Player[];
};

export const registerForEvent = async (eventId: string, payload: EventRegistrationPayload) => {
  const response = await api.post<ApiResponse<Registration>>(
    `/api/v1/registrations/events/${eventId}/register`,
    payload
  );
  return response.data;
};

export const getRegistration = async (registrationId: string) => {
  const response = await api.get<ApiResponse<Registration>>(
    `/api/v1/registrations/${registrationId}`
  );
  return response.data;
};

export const getMyRegistrations = async () => {
  const response = await api.get<ApiResponse<Registration[]>>('/api/v1/registrations');
  return response.data;
};
